/* @flow */

export default class ProvidedDocument {
  id: number;
  typeId: number;
  code: string;
  filename: string;
  name: string;
}
